<template>
    <div class="topbar_container" v-if="false">
        <van-nav-bar :title="title" :left-arrow="leftArrow" @click-left="onClickLeft" :safe-area-inset-top="true" :placeholder="true">
            <template #right>
                <slot name="right"></slot>
            </template>
        </van-nav-bar>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        leftArrow:{
            type: Boolean,
            default: true
        }
    },
    methods: {
        onClickLeft() {
            this.$emit('routerBack')
        }
    }
}
</script>

<style lang="scss" scoped>
.topbar_container{
    z-index: 99;
    width: 100%;
    position: fixed;
    top: 0;
    .van-nav-bar{
        height: 50px;
    }
}
</style>